import { useSelector } from 'react-redux';
import { Table } from '@quintoandar-tokko/jopijs';
import ConversionRateTableRow from './ConversionRateTableRow';
import CollapsibleRow from '../components/CollapsibleRow';
import LoadingMoreSkeleton from '../components/LoadingMoreSkeleton';

export default function ConversionRateGroupedTableContent({ headers }) {
  const { conversionRate } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );

  return (
    <Table.Rows>
      {conversionRate.branches.map((branch) => {
        const items = [
          `${branch.branch.name} (${branch.agents?.length})`,
          branch.conversion_rate,
          branch.assigned_contacts,
          branch.with_visits,
          branch.with_reservations,
          branch.concreted,
          branch.lost,
          branch.in_progress,
        ];

        return (
          <CollapsibleRow key={branch.branch_id} items={items}>
            {branch?.agents?.map((agent, index) => (
              // eslint-disable-next-line
              <ConversionRateTableRow key={index} row={agent} />
            ))}
          </CollapsibleRow>
        );
      })}

      {conversionRate.loading && (
        <LoadingMoreSkeleton columns={headers.length} />
      )}
    </Table.Rows>
  );
}
